import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import pdf from '../../assets/images/file-pdf-solid.svg';
import csv from '../../assets/images/file-csv-solid.svg';
import { useAuth } from '../../hooks/customers/AuthProvider';
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";
import Select from "react-select";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { LoaderContext } from "../utils/Contexts";
//import 'rsuite/dist/rsuite.min.css';
import { DateRangePicker, Stack } from 'rsuite';
import { Link } from "react-router-dom";

const columns = [
  { name: 'Branch', selector: row => row.branch, sortable: true },
  { name: 'PO No.', selector: row => row.poNo, sortable: true },
  { name: 'Delivery Date', selector: row => row.deliveryDate.display, sortable: true },
  {
    name: 'Invoice No.', selector: row => row.invoiceNo, sortable: true, cell: row => (
      <Link to={`/invoice/pdf/${row.id}`} target="_blank">
        {row.invoiceNo}
      </Link>
    )
  },
  { name: 'Total Spent', selector: row => `${row.totalSpent}`, sortable: true },
  {
    name: 'Payment Status',
    selector: row => row.status,
    cell: row => (
      <span style={{ fontWeight: '500', color: row.status === 'Paid' ? '#018c8f' : '#d70601' }}>
        {row.status}
      </span>
    ),
    sortable: true
  },
];

function Reportdatatable({ setInvoicesByMonth, setMonthlyPaidStatusCounts, setMonthlyPaidStatusAmounts }) {

  const pickerRef = useRef(null);
  const popupRef = useRef(null);
  const [active, setActive] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [initialData, setInitialData] = useState([]);
  const [backendTotals, setBackendTotals] = useState({
    thisMonth: 0,
    lastMonth: 0,
    twoMonthsAgo: 0
  });

  const [currentPage, setCurrentPage] = useState(1);
  //const rowsPerPage = 10;
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [inputKeyword, setInputKeyword] = useState('');
  const [filters, setFilters] = useState({
    keyword: '',
    branch: '',
    date: {
      start: null,
      end: null
    },
    paid: true,
    outstanding: true,
  });
  const auth = useAuth();
  const customerId = auth.customer.id;
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [invoice, setInvoice] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const { isLoader, setLoader } = useContext(LoaderContext);
  const [hasLoaded, setHasLoaded] = useState(false);
  //const [range, setRange] = useState([null, null]);
  const [range, setRange] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [chartData, setChartData] = useState({
    monthlyPaidStatusCounts: null,
    monthlyPaidStatusAmounts: null
  });

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/rsuite@latest/dist/rsuite.min.css';
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link); // clean up
    };
  }, []);

  const getBranches = async () => {
    const url = `${ENDPOINTS.GET_BRANCHES}/${customerId}`;
    const response = await API.postWithToken(url);
    if (response.statusText === 'OK') {
      const branchOptions = response?.data?.data.items.map(branch => ({
        value: branch.id,
        label: branch.company,
      }));
      const allOption = { value: '', label: 'All' };
      setBranches([allOption, ...branchOptions]);
    }
  }

  const getInvoiceDetails = async (company) => {
    setLoader(true);
    let url = `${ENDPOINTS.GET_INVOICE_DETAILS}/?id=${customerId}&page=${currentPage}&limit=${rowsPerPage}`;
    if (company && company != 'All') {
      url += `&company=${encodeURIComponent(company)}`;
    }
    if (filters.keyword) {
      url += `&search=${encodeURIComponent(filters.keyword)}`;
    }
    const paidStatus = [];
    if (filters.paid) paidStatus.push('PAID');
    if (filters.outstanding) paidStatus.push('OUTSTANDING');

    if (paidStatus.length > 0) {
      for (const status of paidStatus) {
        url += `&paid_status=${status}`;
      }
    }

    // if (filters.date) {
    //   url += `&date=${filters.date}`;
    // }

    if (filters.date?.start) {
      url += `&start_date=${filters.date.start}`;
    }

    if (filters.date?.end) {
      url += `&end_date=${filters.date.end}`;
    }
    const response = await API.postWithToken(url);
    if (response.statusText === 'OK') {
      const responseData = response?.data?.data.items;

      setInvoice(responseData.data);

      setTotalRows(responseData.pagination.total);

      setBackendTotals(responseData.totals || {
        currentMonth: 0,
        lastMonth: 0,
        twoMonthsAgo: 0
      });
      setChartData({
        monthlyPaidStatusCounts: responseData.monthlyPaidStatusCounts || null,
        monthlyPaidStatusAmounts: responseData.monthlyPaidStatusAmounts || null
      });


      setHasLoaded(true);
      setLoader(false);
    }
  }
  useEffect(() => {
    getBranches();
  }, []);

  useEffect(() => {
    getInvoiceDetails(selectedBranch?.label);
  }, [selectedBranch, filters, currentPage, rowsPerPage]);

  useEffect(() => {
    if (branches.length > 0 && !selectedBranch) {
      setSelectedBranch(branches[0]);
    }
  }, [branches]);

  useEffect(() => {

    if (!filteredData.length) {
      setMonthlyPaidStatusCounts(null);
      setMonthlyPaidStatusAmounts(null);
      return;
    }
    if (
      !chartData.monthlyPaidStatusCounts ||
      !chartData.monthlyPaidStatusAmounts
    ) {
      return;
    }

    const filteredCounts = JSON.parse(
      JSON.stringify(chartData.monthlyPaidStatusCounts)
    );

    const filteredAmounts = JSON.parse(
      JSON.stringify(chartData.monthlyPaidStatusAmounts)
    );

    Object.keys(filteredCounts).forEach(month => {

      if (!filters.paid) {
        filteredCounts[month].paid = 0;
        filteredAmounts[month].paid = 0;
      }

      if (!filters.outstanding) {
        filteredCounts[month].outstanding = 0;
        filteredAmounts[month].outstanding = 0;
      }
    });

    setMonthlyPaidStatusCounts(filteredCounts);

    setMonthlyPaidStatusAmounts(filteredAmounts);

  }, [
    chartData,
    filters.paid,
    filters.outstanding
  ]);

  useEffect(() => {
    setInvoicesByMonth({
      thisMonth: backendTotals.thisMonth || 0,
      lastMonth: backendTotals.lastMonth || 0,
      twoMonthsAgo: backendTotals.twoMonthsAgo || 0
    });
  }, [backendTotals]);

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setCurrentPage(1);

    setFilters(prev => ({
      ...prev,
      [id]: type === 'checkbox' ? checked : value,
    }));
  };

  const resetFilters = () => {
    setInputKeyword('');
    setFilters({
      keyword: '',
      branch: '',
      date: '',
      paid: true,
      outstanding: true,
    });
  };

  const handleSearch = () => {
    setFilters(prev => ({
      ...prev,
      keyword: inputKeyword,
    }));
  };
  const getDecimal = (val) => {
    if (!val) return 0;
    if (typeof val === 'object' && '$numberDecimal' in val) {
      return parseFloat(val.$numberDecimal);
    }
    return parseFloat(val);
  };

  const mapResponseToInitialData = (data) => {
    return data.map(item => {
      const delivery = new Date(item.delivery_date);

      return {
        id: item._id,

        branch: item.customer_info?.company || '-',

        poNo:
          item.po_no && item.po_no.trim() !== ''
            ? item.po_no
            : '-',

        deliveryDate: {
          raw: item.delivery_date,
          display: delivery.toLocaleDateString('en-GB')
        },

        invoiceNo: item.reference_no,

        totalSpent: `$${parseFloat(item.inv_total || 0).toLocaleString(
          undefined,
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        )}`,

        status:
          item.paid_status === 'OUTSTANDING'
            ? 'Outstanding'
            : 'Paid'
      };
    });
  };

  useEffect(() => {
    if (!Array.isArray(invoice)) return;

    const mappedData = mapResponseToInitialData(invoice);

    setInitialData(mappedData);
  }, [invoice]);

  const filteredData = useMemo(() => {
    return initialData.filter(row => {
      const keyword = filters.keyword.toLowerCase();

      const matchKeyword =
        !filters.keyword ||
        Object.values(row).some(val => {
          if (typeof val === 'object' && val !== null) {
            return Object.values(val).some(inner =>
              String(inner).toLowerCase().includes(keyword)
            );
          }

          return String(val).toLowerCase().includes(keyword);
        });

      const matchStatus =
        (filters.paid && row.status === 'Paid') ||
        (filters.outstanding && row.status === 'Outstanding');

      return matchKeyword && matchStatus;
    });
  }, [initialData, filters]);

  // useEffect(() => {
  //   if (!Array.isArray(invoice)) return;

  //   const now = new Date();
  //   const thisMonth = now.getMonth();
  //   const lastMonth = (thisMonth - 1 + 12) % 12;
  //   const twoMonthsAgo = (thisMonth - 2 + 12) % 12;
  //   const thisYear = now.getFullYear();

  //   const invoicesByMonth = {
  //     thisMonth: 0,
  //     lastMonth: 0,
  //     twoMonthsAgo: 0
  //   };

  //   const monthlyPaidStatusCounts = {
  //     thisMonth: { paid: 0, outstanding: 0 },
  //     lastMonth: { paid: 0, outstanding: 0 },
  //     twoMonthsAgo: { paid: 0, outstanding: 0 }
  //   };

  //   const monthlyPaidStatusAmounts = {
  //     thisMonth: { paid: 0, outstanding: 0 },
  //     lastMonth: { paid: 0, outstanding: 0 },
  //     twoMonthsAgo: { paid: 0, outstanding: 0 }
  //   };

  //   if (!invoice.length) {
  //     setInvoicesByMonth(null);

  //     setMonthlyPaidStatusCounts(null);

  //     setMonthlyPaidStatusAmounts(null);

  //     return;
  //   }

  //   invoice.forEach(item => {

  //     // Apply payment status filter for chart
  //     if (
  //       (item.paid_status === 'PAID' && !filters.paid) ||
  //       (item.paid_status === 'OUTSTANDING' && !filters.outstanding)
  //     ) {
  //       return;
  //     }

  //     const delivery = new Date(item.delivery_date);
  //     const month = delivery.getMonth();
  //     const year = delivery.getFullYear();

  //     const amount = parseFloat(
  //       parseFloat(item.inv_total || 0).toFixed(2)
  //     );

  //     let monthKey = null;

  //     if (year === thisYear && month === thisMonth) {
  //       monthKey = 'thisMonth';
  //     } else if (year === thisYear && month === lastMonth) {
  //       monthKey = 'lastMonth';
  //     } else if (year === thisYear && month === twoMonthsAgo) {
  //       monthKey = 'twoMonthsAgo';
  //     }

  //     if (!monthKey) return;

  //     invoicesByMonth[monthKey] += amount;

  //     if (item.paid_status === 'PAID') {
  //       monthlyPaidStatusCounts[monthKey].paid += 1;
  //       monthlyPaidStatusAmounts[monthKey].paid += amount;
  //     } else {
  //       monthlyPaidStatusCounts[monthKey].outstanding += 1;
  //       monthlyPaidStatusAmounts[monthKey].outstanding += amount;
  //     }
  //   });

  //   Object.keys(invoicesByMonth).forEach(key => {
  //     invoicesByMonth[key] = parseFloat(
  //       invoicesByMonth[key].toFixed(2)
  //     );
  //   });

  //   Object.keys(monthlyPaidStatusAmounts).forEach(key => {
  //     monthlyPaidStatusAmounts[key].paid = parseFloat(
  //       monthlyPaidStatusAmounts[key].paid.toFixed(2)
  //     );

  //     monthlyPaidStatusAmounts[key].outstanding = parseFloat(
  //       monthlyPaidStatusAmounts[key].outstanding.toFixed(2)
  //     );
  //   });

  //   setInvoicesByMonth(invoicesByMonth);
  //   setMonthlyPaidStatusCounts(monthlyPaidStatusCounts);
  //   setMonthlyPaidStatusAmounts(monthlyPaidStatusAmounts);

  // }, [invoice, filters.paid, filters.outstanding]);


  const handleBranchChange = (selected) => {
    setCurrentPage(1);

    setSelectedBranch(selected);
  };

  const handleExportCSV = () => {
    const headers = columns.map(col => col.name);
    const rows = filteredData.map(row => {
      return columns.map(col => {
        const cell = typeof col.selector === 'function' ? col.selector(row) : row[col.selector];
        return `"${(cell && typeof cell === 'object' && 'display' in cell) ? cell.display : cell}"`;
      }).join(',');
    });

    const csvContent = [headers.join(','), ...rows].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'billing_report.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const handleExportPDF = () => {
    const doc = new jsPDF();

    const headers = [columns.map(col => col.name)];
    const data = filteredData.map(row =>
      columns.map(col => {
        const value = typeof col.selector === 'function' ? col.selector(row) : row[col.selector];
        return (value && typeof value === 'object' && 'display' in value) ? value.display : value;
      })
    );

    doc.autoTable({
      head: headers,
      body: data,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [52, 73, 94] },
    });

    doc.save('billing_report.pdf');
  };

  return (
    <div className={`reporttables ${filteredData.length === 0 ? 'empty' : ''}`}>
      <div className="filters">
        <div className="divtabe1">
          <label className="labels">Search Keyword</label>
          {/* <input
            type="text"
            id="inputKeyword"
            value={inputKeyword}
            onChange={handleChange}
            placeholder=""
          /> */}
          <input
            type="text"
            id="keyword"
            value={filters.keyword}
            onChange={handleChange}
            placeholder=""
          />
        </div>
        <div className="divtabe1">
          <label className="labels">Branch</label>
          {/* <select id="branch" value={filters.branch} onChange={handleChange}>
            <option value="">All Branches</option>
            <option value="Paya Lebar">Paya Lebar</option>
            <option value="Bishan">Bishan</option>
          </select> */}
          <Select
            options={branches}
            value={selectedBranch}
            onChange={handleBranchChange}
            classNamePrefix="custom-select"
          />
        </div>
        {/* <div className="divtabe1">
          <label className="labels">Select By Date Range</label>
         
          <DatePicker
            selected={filters.date ? new Date(filters.date) : null}
            onChange={(date) => {
              //const formattedDate = date ? date.toISOString().split('T')[0] : '';
              const formattedDate = date
                ? date.toLocaleDateString('en-CA')
                : '';
              setFilters(prev => ({
                ...prev,
                date: formattedDate,
              }));
            }}
            placeholderText=" "
            dateFormat="dd/MM/yyyy"
          />
        </div> */}
        {/* <div className="divtabe1">
          <label className="labels">Select By Date Range</label>
          <DateRangePicker id="date" format="dd/MM/yyyy" value={range}
            onChange={(newRange) => {
              setRange(newRange);
            }} placeholder=" " />
        </div> */}
        <div className="divtabe1">
          <label className="labels">From Date</label>
          <DatePicker
            selected={fromDate}
            onChange={(date) => {
              setFromDate(date);
              setToDate(null);
              setFilters(prev => ({
                ...prev,
                date: {
                  ...prev.date,
                  start: date ? date.toLocaleDateString('en-CA') : null
                }
              }));
            }}
            placeholderText=""
            dateFormat="dd/MM/yyyy"
          />
        </div>

        <div className="divtabe1">
          <label className="labels">To Date</label>
          <DatePicker
            selected={toDate}
            onChange={(date) => {
              setToDate(date);
              setFilters(prev => ({
                ...prev,
                date: {
                  ...prev.date,
                  end: date ? date.toLocaleDateString('en-CA') : null
                }
              }));
            }}
            placeholderText=""
            dateFormat="dd/MM/yyyy"
            minDate={fromDate}
            disabled={!fromDate}
          />
        </div>

        <div className="divtabe1">
          <label className="labels">Payment Status</label>
          <div className="reportcheckbox"><label>
            <input className={filters.paid ? 'checked' : 'unchecked'}
              type="checkbox"
              id="paid"
              checked={filters.paid}
              onChange={handleChange}
            /> Paid
          </label>
            <label>
              <input className={filters.outstanding ? 'checked' : 'unchecked'}
                type="checkbox"
                id="outstanding"
                checked={filters.outstanding}
                onChange={handleChange}
              /> Outstanding
            </label></div>
        </div>
        <div className="divtabe1">
          <label className="labels">Export Table To</label>
          <div className="reportexport">
            <img src={pdf} alt="files" onClick={handleExportPDF} />
            <img src={csv} alt="files" onClick={handleExportCSV} />
          </div>
        </div>
        {/* <div className="divtabe1">
          <label className="labels">1</label>
          <button className="seachbtn"
            onClick={handleSearch}>
            Search
          </button>
        </div>
        <div className="divtabe1">
          <label className="labels">1</label>
          <button className="resetbtn"
            onClick={resetFilters}>
            Reset
          </button>
        </div> */}

      </div>
      {hasLoaded && (
        <>
          <DataTable
            columns={columns}
            //data={filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)}
            data={filteredData}
            pagination
            paginationServer
            // paginationTotalRows={filteredData.length}
            paginationTotalRows={totalRows}
            onChangePage={page => setCurrentPage(page)}
            onChangeRowsPerPage={(newPerPage) => {
              setRowsPerPage(newPerPage);
              setCurrentPage(1);
            }}
            //paginationRowsPerPageOptions={[20, 50, 100]}
            paginationRowsPerPageOptions={[20, 50, 100]}
            paginationComponentOptions={{
              rowsPerPageText: "Rows per page",
              rangeSeparatorText: "of",
              selectAllRowsItem: true,
              selectAllRowsItemText: "All"
            }}
            striped
            highlightOnHover
            responsive

          />
          {/* <div className="reportsizelists">
            Showing {filteredData.length === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1}
            &nbsp;to&nbsp;
            {Math.min(currentPage * rowsPerPage, filteredData.length)} of {filteredData.length} entries
          </div> */}
          <div className="reportsizelists">
            Showing {totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1}
            &nbsp;to&nbsp;
            {Math.min(currentPage * rowsPerPage, totalRows)} of {totalRows} entries
          </div>
        </>
      )}
    </div>


  );
}

export default Reportdatatable;